import * as React from 'react';
import GamePageLayout from '../../../components/GamePageLayout';
import GameNavbar from "../../../components/GameNavbar";
import GameHeader from "../../../components/GameHeader";
import './styles.css'
import {Util} from 'baziigram'
import {dictionary} from "../../../constants"
import {gameDictionary} from "../../../constants/gameHelp.js"


const HelpPage = () => {

    const [language , setLanguage] = React.useState(null)
    const [className , setClassName] = React.useState("rtl text-right")

    React.useEffect(()=>{
    setLanguage(Util.getLanguage())
    if(language == "en")
    setClassName("ltr text-left")
    },[language])


    return (
        <GamePageLayout >
            <GameNavbar />
            <div className={"rtl"}>
                <GameHeader/>


                <div id={"news"} className='help_container rtl'>


                    <h1 className="games">{gameDictionary.help[language]}</h1>
                    <div className={"text-right my-4"}>
                    <h2 className={"text-warning"}>داستان بازی:</h2>
                        <p>
                            اینجا سرزمین بازیگرام است. <br/>در ایران قبیله ای از بازی های دیجیتال وجود داشتند که علی رغم اینکه مردم آنها را دوست داشتند اما این قبیله هیچ جایی برای زندگی نداشت و
                            همیشه سرگردان بود. <br/>تا اینکه ققنوس آنها را پیدا کرد و در این سرزمین آنها را اسکان داد.
                            بازی ها خوشحال بودند که سرزمینی مختص خودشان دارند و با شادی زندگی میکردند تا اینکه اهریمن پوچستان به اینجا حمله کرد و روز را از این سرزمین دزدید.
                          <br/>
                            برای جنگ با اهریمن باید سنگ زندگی را پیدا کنید.
                            با ققنوس همراه شوید تا دوباره صبح را به این سرزمین برگردانیم.
                        </p>
                        <img alt={"جنگ"} src={"/images/main-page/war.jpg"} width={"95%"}
                             style={{display:"block" , margin:"auto" , borderRadius:"8px" , maxWidth:"350px"}}/>
                    </div>


                    <div className={"text-right my-4"}>
                        <h2 className={"text-warning"}>چرا نیاز به احراز هویت است؟</h2>
                        <p>
                           مزیت بازیگرام نسبت به اکثر بازی های دیجیتال در این است که فیکوین های شما معادل تومان هستند و قابلیت نقد شوندگی تا سقف 40 هزار تومان دارند.<br/>
                            در نتیجه برای حفظ امنیت حساب کاربری شما و ذخیره تغییرات شما نیاز است تا فرآیند احراز هویت از طریق ارسال پیام کوتاه به شماره تلفن همراه شما انجام شود.<br/>
                            در این صورت اگر شما بر روی هر دستگاه دیگری بازیگرام را نصب کنید، تمام تغییرات شما ذخیره شده باقی خواهد ماند و میتوانید ادامه بازی را انجام دهید.
                        </p>
                    </div>

                    <div className={"text-right"}>
                        <h2 className={"text-warning"} style={{display:"inline-block"}}>فیکوین:</h2>  <img alt={"سکه"} className="mr-2 ml-4" src={"/images/icons/coin2.png"} width={"22px"}/>

                        <p>
                            <br/>فیکوین واحد پول سرزمین بازیگرام است. هر فیکوین معادل یک تومان است.
                            شما میتوانید در هر یک از بازی ها، با بازی کردن فیکوین جمع آوری کنید و در نهایت با این فیکوین ها میتوانید در صورتی که تمایل ندارید مرحله ای را بازی کنید آن را از "فروشگاه"
                            بخرید و به مرحله بعد بروید.<br/>
                            همچنین فیکوین ها از طریق منوی پروفایل در بازی ها، قابل تبدیل به رمز شارژ و کد تخفیف هم هستند.
                        </p>
                        1: <img alt={"راهنما"}  src={"/images/main-page/help1.png"}/>
                        <br/>
                        2: <img alt={"راهنما"}  src={"/images/main-page/help2.png"}/>
                        <br/>
                        3: <img  alt={"راهنما"} src={"/images/main-page/help3.png"}/>
                        <br/>
                    </div>

                    <div className={"text-right my-4"}>
                        <h2 className={"text-warning"}>جایزه روزانه:</h2>
                        <p>
                            شما در صورتی که هر روز  به بازیگرام سر بزنید تعدادی فیکوین به عنوان هدیه دریافت خواهید کرد
                        </p>
                    </div>

                    <div className={"text-right my-4"}>
                        <h2 className={"text-warning"}>اشتراک گذاری:</h2>
                        <p>
                           در صورتی که با پیام
                            <span className={"text-warning mx-1"}>«کاربر گرامی، در صورت به اشتراک گذاری لینک زیر n
                             سکه می گیرید»</span>
                            مواجه شدید، باید بر روی دکمه اشتراک گذاری کلیک کرده و لینک را برای یکی از دوستانتان ارسال کنید. زمانی که دوست شما بر روی لینک کلیک کند سکه های شما به حسابتان منتقل میشود.
                             </p>
                    </div>

                    <div className={"text-right my-4"}>
                        <h2 className={"text-warning"} style={{display:"inline-block"}}>خبرستان:</h2> <img alt={"اخبار"} height={"30px"} width={"30px"} src={"/images/main-page/post.png"}/>

                        <p>
                           شما در خبرستان میتوانید اخبار سرزمین بازیگرام را مشاهده نمایید
                        </p>
                    </div>

                    <div className={"text-right  my-4"}>
                        <h2 className={"text-warning"} style={{display:"inline-block"}}>فروشگاه:</h2>  <img alt={"فروشگاه"} height={"30px"} width={"30px"} src={"/images/main-page/store.png"}/>

                        <p>
                           در قسمت فروشگاه میتوانید موارد موردنیاز برای رد کردن مراحلی که تمایل به بازی کردن آنها ندارید را با فیکوین های خود بخرید و از آن مرحله عبور کنید
                        </p>
                    </div>

                </div>


            </div>

        </GamePageLayout>
    )
}

export default HelpPage;
